import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/mvv/Mvv'

const Brands: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'ミッション mission ビジョン vision バリュー value'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/mvv/'}
        title="当社が目指しているもの | 私たちについて | Aitria（アイトリア）"
        description="Aitria（アイトリア）が果たすべき使命、目指す姿、私たちが大切にする価値について紹介しています。"
      />
      <Template />
    </>
  )
}

export default Brands
